/* unplugin-vue-components disabled */import { render } from "./Base2.vue?vue&type=template&id=665c97b4"
import script from "./Base2.vue?vue&type=script&lang=js"
export * from "./Base2.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__